<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 28 28"><path fill="currentColor" d="m1.81 12.19 3.44-3.44L14 0l8.75 8.75 3.44 3.44a6.188 6.188 0 0 1-8.75 8.75l-1.69-1.69v5.25h3.5V28H8.75v-3.5h3.5v-5.25l-1.69 1.69a6.188 6.188 0 0 1-8.75-8.75"/></svg>
</template>